import { Outlet, NavLink, Link } from 'react-router-dom'
import { Home, FlaskConical, UserCheck, Target } from 'lucide-react'

const navItems = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/research', label: 'Consultant Research', icon: FlaskConical },
  { to: '/profiles', label: 'Profiles', icon: UserCheck },
  { to: '/matching', label: 'Matching', icon: Target },
]

export default function RootLayout() {
  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <div className="flex items-center justify-between px-6 py-3">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center">
              <img src="/nn-logo.svg" alt="NN" className="h-8" />
            </Link>
            <div className="h-6 w-px bg-gray-300" />
            <span
              className="text-sm font-semibold tracking-wider text-gray-700"
              style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace' }}
            >
              PROFILING INTELLIGENCE
            </span>
          </div>
          <nav className="flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-1.5 text-sm transition-colors ${
                    isActive
                      ? 'bg-[#F17922]/10 text-[#F17922] font-medium'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`
                }
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  )
}
